exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".customerServiceCenterDetailBox {\n  background-color: #F4F4F5;\n  min-height: 100vh;\n}\n.customerServiceCenterDetailBox .contentBox {\n  padding: 0 0.12rem;\n  background-color: #fff;\n}\n.customerServiceCenterDetailBox .contentBox h1 {\n  margin: 0;\n  color: #333333;\n  font-size: 0.18rem;\n  border-bottom: 1px solid #EBEBEB;\n  padding: 0.2rem 0;\n}\n.customerServiceCenterDetailBox .contentBox .contentHtml {\n  padding: 0.16rem 0;\n}\n.customerServiceCenterDetailBox .notSolved {\n  color: #666666;\n  font-size: 0.14rem;\n  text-align: center;\n  margin: 0.16rem 0;\n}\n.customerServiceCenterDetailBox .notSolved a {\n  margin-left: 0.04rem;\n  color: #289BF8;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/customerServiceCenter/detail/index.less
// module id = 1065
// module chunks = 0